





/* jshint nomen:false */
define(['leaflet', 't', 'unitFormatConverter/unitFormatConverter', 'services/utils'], function(L, T, units, Utils) {
    'use strict';

    var iconsMapping = {
        'Unknown': 'danger',
        'Accident': 'accident',
        'Fog': 'danger',
        'Dangerous Conditions': 'danger',
        'Rain': 'danger',
        'Ice': 'ice',
        'Jam': 'incident',
        'Lane Closed': 'laneclosed',
        'Road Closed': 'roadclosed',
        'Road Works': 'roadwork',
        'Wind': 'danger',
        'Flooding': 'danger',
        'Detour': 'danger',
        'Cluster': ''
    };
    var messageTemplate = new T(
        '    <div class="traffic-details">' +
            '    <div class="traffic-icon">' +
            '        <div class="icon-circle-{{=incidentSeverity}}">' +
            '            <div class="icon-{{=icon}}-white"></div>' +
            '        </div>' +
            '    </div>' +
            '    {{roadNumber}}' +
            '        <div class="road-shield">{{=roadNumber}}</div>' +
            '    {{/roadNumber}}' +
            '    <div class="traffic-description">' +
            '        <div class="incident-category">{{=incidentCategory}}</div>' +
            '        <div' +
            '            class="incident-delay-length"' +
            '            {{!delaySeconds}}' +
            '                {{!lengthMeters}}' +
            '                    style="display:none;"' +
            '                {{/!lengthMeters}}' +
            '            {{/!delaySeconds}}' +
            '        >' +
            '            {{delaySeconds}}' +
            '                <div class="incident-delay">{{=time}}</div>' +
            '            {{/delaySeconds}}' +
            '            {{lengthMeters}}' +
            '                <div class="incident-length">{{=distance}}</div>' +
            '            {{/lengthMeters}}' +
            '        </div>' +
            '    </div>' +
            '</div>'
    );

    function trafficIncidentMessage(info, isUsingImperialUnits) {
        info.distance = units.formatDistance(info.lengthMeters, isUsingImperialUnits);
        info.time = units.formatTime(info.delaySeconds);
        info.incidentSeverity = info.incidentSeverity || 'unknown';
        info.icon = iconsMapping[info.incidentCategory];
        return messageTemplate.render(info);
    }

    function getIconOptions(feature) {
        var severity = feature.properties.incidentSeverity || 'unknown';

        return {
            popupAnchor: [0, -5],
            background: { iconSize: [20, 20], iconAnchor: [10, 10], icon: 'icon-circle-' + severity },
            icon: {
                iconSize: [20, 20],
                iconAnchor: [0, 0],
                icon: 'icon-' + iconsMapping[feature.properties.incidentCategory] + '-white'
            },
            content: {
                content: null,
                iconSize: [20, 20],
                iconAnchor: [0, 0],
                style: { 'color': '#fff', 'font-weight': 'bold', 'font-size': '11px' }
            }
        };
    }

    L.Marker.IncidentMarker = L.Marker.extend({
        options: {
            imperialUnits: false
        },
        iconsMapping: iconsMapping,
        initialize: function(feature, latlng, options) {
            L.Util.setOptions(this, options);
            L.Marker.prototype.initialize.call(this, latlng, options);
            this.setFeature(feature);
        },
        setFeature(feature) {
            var previousFeature = this.feature || {};
            this.feature = feature;
            this.setLatLng(this.feature.geometry.coordinates.reverse());
            if (!Utils.isEqual(this.feature.properties, previousFeature.properties)) {
                this._updateIcon();
                this._updatePopup();
            }
        },
        _updateIcon: function() {
            this.setIcon(L.svgIcon(getIconOptions(this.feature)));
        },
        _updatePopup: function() {
            var popupContent = trafficIncidentMessage(this.feature.properties, this.options.imperialUnits);
            if (this.getPopup()) {
                this.setPopupContent(popupContent);
            } else {
                this.bindPopup(popupContent, { className: 'incidents-popup' });
            }
        }
    });

    return function(feature, latlng, options) {
        if (!feature || !feature.properties) {
            return null;
        }

        return new L.Marker.IncidentMarker(feature, latlng, {
            imperialUnits: (options || {}).imperialUnits
        });
    };
});



// WEBPACK FOOTER //
// ./display/layers/markers/incidentMarker.js